let SERVER_URL = "https://api.youthbuildprov.org";
/* 
RED_DIVIDER helps determine fail rate. If the number of non-green indicators falls
below the product of indicators divided by this number, the parent shortcode will
turn red. Any yellow or red values will turn the parent shortcode yellow.
*/ 
let RED_DIVIDER = 2;
let WARN_DIVIDER = 4;
export {SERVER_URL, RED_DIVIDER, WARN_DIVIDER};
